import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { IndicatorService } from '@services/indicator.service';
import { Fade } from '@util/animations';

@Component({
  selector: 'vnm-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss'],
  animations: [Fade]
})
export class ContentHeaderComponent {
  @Input() loading = false;
  @Input() header: string;
  @Input() info: string | null;
  // supply true if you require flex row for mobile header
  @Input() contentRow = false;

  @ContentChild('header', { static: true }) headerTemplate: TemplateRef<void> | null;
  @ContentChild('contentActions', { static: true }) contentActions: TemplateRef<void> | null;
  @ContentChild('headerActions', { static: true }) headerActions: TemplateRef<void> | null;
  @ContentChild('navActions', { static: true }) navActions: TemplateRef<void> | null;

  constructor(public indicator: IndicatorService) {}
}
